module.exports = __webpack_public_path__ + "img/17.5555de3b.png";